import Request from "@/services/request";
import loginRedirector from "@/utils/enum/loginRedirector";
import {
  PERSIST_USER,
  AFTER_LOGIN_QUERY,
  AUTH_LOGOUT,
  PUBLIC_COOKIE,
} from "@/utils/enum/endpoints";
import {
  GET_SELLER_ID_FROM_COOKIE,
  PERSIST_USER_DATA_PENDING,
  PERSIST_USER_DATA_SUCCESS,
  PERSIST_USER_DATA_FAIL,
  LOGOUT_PENDING,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  SET_LOGIN_STATUS,
} from "./mutation-types";

const request = new Request();

const getPublicCookie = async () => {
  await request.post(PUBLIC_COOKIE, {});
};

const persistUserData = async ({ commit }) => {
  commit(PERSIST_USER_DATA_PENDING);
  try {
    const { data } = await request.get(PERSIST_USER);
    commit(PERSIST_USER_DATA_SUCCESS, data.additionalProperties);

    if (data.tokenType === "anonymous") {
      const loginStatus = {
        isLoggedIn: false,
        isAnonymous: true,
      };
      commit(SET_LOGIN_STATUS, loginStatus);
      return Promise.resolve(loginStatus);
    }

    commit(GET_SELLER_ID_FROM_COOKIE, data.additionalProperties.sellerId);
    const loginStatus = {
      isLoggedIn: data.additionalProperties.status !== "NEWSIGNUP",
      isAnonymous: false,
    };
    commit(SET_LOGIN_STATUS, loginStatus);
    return Promise.resolve(loginStatus);
  } catch ({ data }) {
    commit(PERSIST_USER_DATA_FAIL, data.errors && data.errors[0]?.reason);
    const loginStatus = {
      isLoggedIn: false,
      isAnonymous: false,
    };
    commit(SET_LOGIN_STATUS, loginStatus);
    return Promise.resolve(loginStatus);
  }
};

const getSellerLoginModal = async ({ state }) => {
  try {
    const { sellerId } = state.user;
    const { data } = await request.post(AFTER_LOGIN_QUERY, {
      sellerId,
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
};

const logout = async ({ commit }) => {
  commit(LOGOUT_PENDING);
  try {
    await request.post(AUTH_LOGOUT);
    commit(LOGOUT_SUCCESS);
    await getPublicCookie();
    loginRedirector();
  } catch ({ data }) {
    commit(LOGOUT_FAIL, data && data.message);
  }
};

export default {
  persistUserData,
  getSellerLoginModal,
  logout,
};
